var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"xs":{span: 24},"sm":{span: 24}}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }